import {
  type AllocationBE,
  getEntitySubAccountNames,
  type IAllocation,
  type TradeSettleStatusEnum,
} from '@talos/kyoko';
import type { LPSettlementReport } from '../../types';

export type LPSettlementReportBlotterRow = TradeRow;

export function lpSettlementReportBlotterRow(row: LPSettlementReport): LPSettlementReportBlotterRow[] {
  const tradeRow = new TradeRow(row);

  return [tradeRow];
}

export class TradeRow {
  RowID: string;
  EventID: string;
  EventType: string;
  MarketAccount: string;
  Counterparty: string;
  Allocation: IAllocation | undefined;
  SettleStatus: TradeSettleStatusEnum;
  SettleDeadline: string;
  EventTransactTime: string;
  EventSide: string;
  EventPrice?: string;
  BaseLeg: LPSettlementReport['BaseLeg'];
  QuoteLeg: LPSettlementReport['QuoteLeg'];
  Revision: number;
  subAccounts: string[] | undefined;

  constructor(row: LPSettlementReport) {
    this.RowID = `${row.EventID}`;
    this.EventID = row.EventID;
    this.EventType = row.EventType;
    this.MarketAccount = row.MarketAccount;
    this.Counterparty = row.Counterparty;

    this.Allocation = row.Allocation;
    this.SettleStatus = row.SettleStatus;
    this.SettleDeadline = row.SettleDeadline;
    this.EventTransactTime = row.EventTransactTime;
    this.EventSide = row.EventSide;
    this.EventPrice = row.EventPrice;
    this.BaseLeg = row.BaseLeg;
    this.QuoteLeg = row.QuoteLeg;
    this.Revision = row.Revision;

    this.subAccounts = getEntitySubAccountNames({
      SubAccount: row.SubAccount,
      Allocation: row.Allocation as AllocationBE,
    });
  }
}
